import React, {Component} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import {minWidthMedia} from "@irati/ui/src/global/media"
import {getResolvedMessage} from "@irati/utils/lang"

const StyledFullWidthBanner = styled.div`
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  min-height: 200px;
  max-height: 350px;
  background-color: ${(props) => props.color};

  ${minWidthMedia.tablet`
    height: 350px;
  `}

  > img {
    height: 100%;
    width: 100%;
    min-height: 200px;
    max-height: 350px;
    object-fit: cover;
  }
`

class FullWidthBanner extends Component {
  static propTypes = {
    src: PropTypes.string,
    alt: PropTypes.string,
    color: PropTypes.string,
    className: PropTypes.string,
    useImgTag: PropTypes.bool
  }

  static defaultProps = {
    className: null,
    useImgTag: true,
    color: null,
    src: null,
    alt: "perks.components.fullWidthBanner.alt"
  }

  render() {
    const {useImgTag, className, src, color, alt} = this.props
    return <StyledFullWidthBanner color={color} className={className}>
      {useImgTag && <img src={src} alt={alt && getResolvedMessage(this, "alt")} />}
    </StyledFullWidthBanner>
  }
}


export default FullWidthBanner
